import type { DeliveryProfile } from '@/entities/sender.entity';

export type SenderAudienceFilter = 'mutual_only' | 'contacts_and_dialogs';

export const DEFAULT_SENDER_AUDIENCE_FILTER: SenderAudienceFilter = 'contacts_and_dialogs';

export const SENDER_AUDIENCE_FILTER_OPTIONS: ReadonlyArray<{
	value: SenderAudienceFilter;
	label: string;
}> = [
	{
		value: 'mutual_only',
		label: 'Только взаимные контакты',
	},
	{
		value: 'contacts_and_dialogs',
		label: 'Контакты и диалоги',
	},
];

export function resolveSenderAudienceFilter(
	value: SenderAudienceFilter | null | undefined,
): SenderAudienceFilter {
	return value ?? DEFAULT_SENDER_AUDIENCE_FILTER;
}

export function shouldIncludeAudienceFilterInCreateRunForm(deliveryProfileReady: boolean): boolean {
	return deliveryProfileReady;
}

export function isDeliveryProfileReady(
	loading: boolean,
	profile: DeliveryProfile | null,
): boolean {
	return !loading && profile !== null;
}
